
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormDescription, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { User, Phone, Edit } from 'lucide-react';
import PhoneInput from '@/components/PhoneInput';

interface UserFieldGroupProps {
  form: any;
  isEditingName: boolean;
  setIsEditingName: (editing: boolean) => void;
  isEditingPhone: boolean;
  setIsEditingPhone: (editing: boolean) => void;
}

const UserFieldGroup: React.FC<UserFieldGroupProps> = ({
  form,
  isEditingName,
  setIsEditingName,
  isEditingPhone,
  setIsEditingPhone
}) => {
  return (
    <>
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-sm font-medium text-gray-700 flex items-center justify-between">
              <span className="flex items-center gap-2">
                <User className="w-4 h-4" />
                Nom complet *
              </span>
              <Button
                type="button"
                variant="ghost"
                size="sm"
                onClick={() => setIsEditingName(!isEditingName)}
                className="h-auto p-1"
              >
                <Edit className="w-4 h-4" />
              </Button>
            </FormLabel>
            <FormControl>
              <Input
                placeholder="Votre nom complet"
                {...field}
                className="h-12"
                readOnly={!isEditingName}
                style={{ backgroundColor: !isEditingName ? '#f9fafb' : 'white' }}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="phone"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-sm font-medium text-gray-700 flex items-center justify-between">
              <span className="flex items-center gap-2">
                <Phone className="w-4 h-4" />
                Numéro de téléphone *
              </span>
              <Button
                type="button"
                variant="ghost"
                size="sm"
                onClick={() => setIsEditingPhone(!isEditingPhone)}
                className="h-auto p-1"
              >
                <Edit className="w-4 h-4" />
              </Button>
            </FormLabel>
            <FormControl>
              <PhoneInput
                value={field.value}
                onChange={field.onChange}
                placeholder="77123456"
                label=""
                disabled={!isEditingPhone}
              />
            </FormControl>
            <FormDescription>
              Format: 8 chiffres (ex: 77123456)
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};

export default UserFieldGroup;
